define('modules/base/models/identity.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function (_, Backbone, BaseModel) {
    var IdentityModel = BaseModel.extend({
        base: 'identity',
        validateModel:function(){
            return (this.has('name') || this.has('firstName'));
        },
        getName:function(){
            var returnVal = undefined;
            if(this.validateModel()){
                if(this.get('identityType') == 'person'){
                    if(this.has('firstName')){
                        returnVal = this.get('firstName') + " " + this.get('lastName');
                    } else {
                        returnVal = this.get('name');
                    }
                } else {
                    returnVal = this.get('name');
                }
            }
            return returnVal;
        },
        getSourceName:function(){
            var returnVal = undefined;
            if(this.validateModel()){
                returnVal = window.utils.identity.makeSourceName(
                    this.get('source').sourceId
                );
            }
            return returnVal;
        },
        getIcon:function(){
            var returnVal = undefined;
            if(this.validateModel()){
                returnVal = window.utils.identity.getIdentityIcon(
                    this.get('identityType')
                );
            }
            return returnVal;
        },
        urlRoot:function(){
            return window.utils.makeUrl('prospector/v1/' + this.base);
        }
    });
    return IdentityModel;
});

